<template>
  <div class="list-stocks">
    <KTCodePreview v-bind:title="'Danh sách phiếu kiểm tra tồn kho'">
      <template v-slot:toolbar>
        <div class="row">
          <div class="ml-3">
            <b-dropdown
              size="sm"
              right
              split
              variant="primary"
              @click="showCreateModal"
              class="ml-4"
              v-if="checkPermissions(['STOCK_CHECK_INSERT'])"
            >
              <template v-slot:button-content>
                <div class="font-weight-bolder">
                  <span>
                    <i style="font-size: 1rem" class="flaticon2-add-1"></i>Tạo
                    mới</span
                  >
                </div>
              </template>
            </b-dropdown>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <!-- Header session -->
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="params.searchFromDay"
                ></date-picker>
              </b-col>
              <b-col>
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="params.searchToDay"
                ></date-picker>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-form-input
              v-model.trim="params.code"
              type="text"
              placeholder="Mã phiếu kiểm tồn"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-select
              v-model="params.status"
              :options="statusOptions"
              size="sm"
            >
              <template v-slot:first>
                <b-form-select-option :value="null"
                  >Chọn trạng thái</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col>
            <BDropdownCustom
              v-model="valueStore"
              :options="filteredOptionsStore"
              :placeholder="'cửa hàng'"
              :matchKey="['name', 'shortName']"
              :searchable="true"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form-select
              v-model="selectedCompany"
              :options="listCompany"
              value-field="id"
              text-field="name"
              size="sm"
            >
              <template v-slot:first>
                <b-form-select-option :value="null">Tất cả doanh nghiệp</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col>
            <b-form-select
              v-model="selectedProductType"
              :options="productTypeOptions"
              size="sm"
            >
              <template v-slot:first>
                <b-form-select-option :value="null">Tất cả loại phiếu</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col>
            <EmployeeSearch
              v-model="createdByName"
              placeholder="người tạo"
              @employee-selected="onCreatedBySelected"
            />
          </b-col>
          <b-col></b-col>
        </b-row>
        <b-row class="mb-5 mt-3">
          <b-col md="1">
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <!-- End of Header session -->
        <b-table
          :table-class="'table-centered'"
          :items="items"
          :fields="fields"
          head-row-variant="secondary"
          outlined
          :busy="onLoading"
          bordered
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:cell(code)="data">
            <b-link
              id="inventory-check-modal"
              @click="editInventoryCheckItem(data.item)"
            >
              {{ data.item.code }}
            </b-link>
            <CompanyCodeBadge
              class="ml-1"
              :company-code="data.item.companyCode"
              :company-name="data.item.companyName"
            />
          </template>
          <template v-slot:cell(info)="data">
            <ul class="list-unstyled">
              <li>
                <span class="font-weight-bold mr-2">Trạng thái:</span>
                <StatusLabel
                  :status="data.item.status"
                  :statusName="data.item.statusName"
                />
              </li>
              <li>
                <span class="font-weight-bold">Loại phiếu:</span>
                {{ productTypeName[data.item.productType] || 'Tất cả' }}
              </li>
              <li>
                <span class="font-weight-bold">Người tạo:</span>
                {{ data.item.createdByName }}
              </li>
              <li v-if="data.item.managerEmployeeName">
                <span class="font-weight-bold">Quản lý cửa hàng:</span>
                {{ data.item.managerEmployeeName }}
              </li>
              <li>
                <span class="font-weight-bold">Ngày tạo:</span>
                {{ data.item.createdAt }}
              </li>
              <li>
                <span class="font-weight-bold">Số lượng tổng: </span>
                <span class="text-primary">{{
                  data.item.totalSystemQuantity
                }}</span>
              </li>
              <li>
                <span class="font-weight-bold">Số lượng đã kiểm: </span>
                <span class="text-success">{{
                  data.item.totalRealQuantity
                }}</span>
              </li>
              <li>
                <span class="font-weight-bold">Số lượng lệch: </span>
                <span
                  :class="
                    data.item.totalDiffQuantity > 0
                      ? 'text-danger'
                      : 'text-success'
                  "
                >
                  {{ data.item.totalDiffQuantity }}
                </span>
              </li>
            </ul>
          </template>
          <template v-slot:cell(note)="data">
            <p v-if="data.item.note" :title="data.item.note" v-b-tooltip.hover>
              {{ truncateText(data.item.note) }}
            </p>
          </template>
          <template v-slot:cell(systemNote)="data">
            <p
              v-if="data.item.systemNote"
              :title="data.item.systemNote"
              v-b-tooltip.hover
            >
              {{ truncateText(data.item.systemNote) }}
            </p>
          </template>
          <template v-slot:cell(action)="data">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <b-dropdown-item
                 v-if="
                    data.item.status === STOCK_CHECK_SHEET_STATUS.STOCK_DIFF &&
                    checkPermissions(['STOCK_CHECK_MANAGE_ALL', 'STOCK_CHECK_CONFIRM'])
                  "
                 @click="printItem(data.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-printer"></i>
                    &nbsp; In phiếu
                  </span>
                </b-dropdown-item>
                <b-dropdown-item @click="editInventoryCheckItem(data.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Xem chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    data.item.status === STOCK_CHECK_SHEET_STATUS.STOCK_DIFF &&
                    checkPermissions(['STOCK_CHECK_MANAGE_ALL', 'STOCK_CHECK_CONFIRM'])
                  "
                  @click="balanceInventoryCheck(data.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem"
                      class="fas fa-balance-scale text-warning"
                    ></i>
                    &nbsp; Bù trừ kiểm kho
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    data.item.status === STOCK_CHECK_SHEET_STATUS.COMFIRM &&
                    checkPermissions(['STOCK_CHECK_MANAGE_ALL'])
                  "
                  @click="completeStockCheckSheet(data.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem"
                      class="fas fa-check-circle text-success"
                    ></i>
                    &nbsp; Hoàn tất phiếu
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="checkPermissions(['STOCK_CHECK_DELETE'])"
                  @click="
                    showDeleteAlert(
                      'Xoá phiếu kiểm kê',
                      'Bạn có chắc muốn xoá phiếu kiểm kê này!',
                      data.item.id,
                      deleteStockCheckItem,
                    )
                  "
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số :
              {{ totalItem }}
            </p>
          </b-col>
          <b-col>
            <b-col>
              <BPaginationNavCustom
                :number-of-pages="numberOfPage || 1"
                :current-page="page"
                :total-page="numberOfPage || 1"
                :linkParams="{}"
                @page-change="fetchDataCheckSheets()"
              >
              </BPaginationNavCustom>
            </b-col>
          </b-col>
        </b-row>
        <InventoryCheckAddModal
          v-on:fetchInventoryChecks="fetchDataCheckSheets()"
          ref="add-inventory-check-modal"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import InventoryCheckAddModal from '@/view/components/inventoryCheck/InventoryCheckAddModal.vue';
import StatusLabel from '@/view/components/inventoryCheck/StatusLabel.vue';
import CompanyCodeBadge from '@/view/components/common/CompanyCodeBadge.vue';
import EmployeeSearch from '@/view/components/common/EmployeeSearch.vue';
import { removeAccents, makeToastSuccess, handleError } from '@/utils/common';
import { STOCK_CHECK_SHEET_STATUS } from '@/utils/enum';
import { cloneDeep, isNil, omitBy, omit } from 'lodash';
import { showDeleteAlert, showConfirmDialog } from '@/utils/sweet-alert2';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { formatDBDate, DP_CONFIG, getCurrentDate } from '@/utils/date';
import { STOCK_CHECK_SHEET_STATUS_NAME } from '@/utils/enum-name';
import { VclTable } from 'vue-content-loading';
import permissionMixin from '@/view/mixins/permission.mixin';

export default {
  mixins: [permissionMixin],
  data() {
    return {
      page: 1,
      productTypeName: {
        1: 'Sản phẩm',
        2: 'Sản phẩm theo IMEI',
      },
      productTypeOptions: [
        { value: 1, text: 'Sản phẩm' },
        { value: 2, text: 'Sản phẩm theo IMEI' },
      ],
      selectedCompany: null,
      selectedProductType: null,
      createdByEmployeeId: null,
      createdByName: '',
      listCompany: [],
      checkSheets: [],
      valueStore: [],
      filteredOptionsStore: [],
      optionsStore: [],
      totalItem: 0,
      numberOfPage: 0,
      selectedCheckSheetId: null,
      dpConfigs: DP_CONFIG,
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      fields: [
        {
          key: 'code',
          label: 'Mã phiếu',
          thStyle: { width: '15%' },
          tdClass: 'font-weight-bold text-primary text-left  align-middle',
          thClass: 'text-center text-dark',
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          thStyle: { width: '20%' },
          thClass: 'text-center text-dark',
          tdClass: 'text-left  align-middle',
        },
        {
          key: 'info',
          label: 'Thông tin',
          thStyle: { width: '20%' },
          thClass: 'text-center text-dark',
          tdClass: 'text-left  align-middle ',
        },
        {
          key: 'note',
          label: 'Ghi chú',
          thClass: 'text-center text-dark',
          tdClass: 'text-left align-middle',
          thStyle: { width: '20%' },
        },
        {
          key: 'systemNote',
          label: 'Ghi chú lệch tồn',
          thClass: 'text-center text-dark',
          tdClass: 'text-left align-middle',
          thStyle: { width: '20%' },
        },
        {
          key: 'action',
          label: '',
          tdClass: 'text-right align-middle',
          thStyle: { width: '5%' },
          thClass: 'text-center text-dark',
        },
      ],
      items: [],
      onLoading: false,
      statusOptions: Object.values(STOCK_CHECK_SHEET_STATUS).map((status) => ({
        value: status,
        text: STOCK_CHECK_SHEET_STATUS_NAME[status],
      })),
      params: {
        page: 1,
        pageSize: 10,
        searchFromDay: getCurrentDate(),
        searchToDay: '',
        status: null,
        storeIds: [],
        code: null,
      },
      STOCK_CHECK_SHEET_STATUS,
      STOCK_CHECK_SHEET_STATUS_NAME,
    };
  },
  methods: {
    showDeleteAlert,
    fetchStoreByUser() {
      ApiService.get(`v1/stores/get-by-user`).then(({ data }) => {
        const { stores, currentStoreId } = data.data;
        this.optionsStore = stores;
        this.filteredOptionsStore = stores;
        if (currentStoreId) {
          const currentStore = stores.find(
            (store) => store.id === currentStoreId,
          );
          this.valueStore = [
            {
              id: currentStore.id,
              name: currentStore.name,
            },
          ];
        }
      });
    },
    onFilter() {
      this.setParamsFilter();
      this.fetchDataCheckSheets();
    },

    fitlerOptionsBy(items, textInput, prop, limit) {
      return cloneDeep(items)
        .filter((item) => {
          if (item) {
            const nameWTUnicode = removeAccents(item[prop] || '');
            const nameInputWTUnicode = removeAccents(textInput);
            const index = nameWTUnicode
              .toLowerCase()
              .indexOf(nameInputWTUnicode.toLowerCase());

            if (index > -1) {
              return true;
            }
          }
          return false;
        })
        .slice(0, limit);
    },

    editInventoryCheckItem(checkSheet) {
      this.$router.push({
        name: 'upsert-inventory-check',
        query: { id: checkSheet.id },
      });
    },
    showCreateModal() {
      this.$refs['add-inventory-check-modal'].showModal();
    },
    fetchDataCheckSheets: function () {
      this.onLoading = true;
      this.page = this.$route.query.page || 1;
      const params = this.getParamsFilter();
      ApiService.query('v1/stock-check-sheet', {
        params,
      })
        .then(({ data }) => {
          this.totalItem = data.data.totalRow;
          this.numberOfPage = data.data.totalPage;
          this.items = data.data.dataset;
        })
        .catch((err) => {
          handleError(err);
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    setParamsFilter() {
      const params = this.getParamsFilter();
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-inventory-check',
        query: omitBy(omit(params, ['page', 'pageSize']), isNil),
      });
      return params;
    },
    getParamsFilter() {
      const storeIds = this.valueStore.map((element) => element.id);
      return {
        page: this.page,
        pageSize: 10,
        searchFromDay: formatDBDate(this.params.searchFromDay),
        searchToDay: formatDBDate(this.params.searchToDay),
        status: this.params.status,
        code: this.params.code,
        storeIds,
        companyId: this.selectedCompany || undefined,
        productType: this.selectedProductType || undefined,
        createdBy: this.createdByEmployeeId || undefined,
      };
    },
    async fetchCompany() {
      const response = await ApiService.get('v1/companies/all');
      this.listCompany = response.data.data || [];
    },
    onCreatedBySelected(employee) {
      this.createdByEmployeeId = employee ? employee.id : null;
    },
    async deleteStockCheckItem(id) {
      try {
        const response = await ApiService.delete(`v1/stock-check-sheet/${id}`);
        const { message } = response.data;
        this.fetchDataCheckSheets();
        makeToastSuccess(message);
      } catch (err) {
        handleError(err);
      }
    },

    async completeStockCheckSheet(stockCheckSheet) {
      showConfirmDialog(
        'Hoàn tất phiếu kiểm kho?',
        `Bạn có chắc muốn hoàn tất phiếu kiểm kho "${stockCheckSheet.code}"?`,
      )
        .then(() => {
          return this.performCompleteStockCheckSheet(stockCheckSheet.id);
        })
        .catch(() => {});
    },

    async performCompleteStockCheckSheet(id) {
      try {
        const response = await ApiService.put(
          `v1/stock-check-sheet/update-status/${id}`,
          { status: STOCK_CHECK_SHEET_STATUS.DONE },
        );
        const { message, data } = response.data;
        const index = this.items.findIndex((item) => item.id === id);
        this.items[index].status = data.status;
        this.items[index].statusName = data.statusName;
        makeToastSuccess(message);
      } catch (err) {
        handleError(err);
      }
    },
    routeProduct(namePath) {
      this.$router.push({
        name: `${namePath}`,
      });
    },
    truncateText(text) {
      const MAX_STRING = 100;
      if (!text || !text.length) {
        return '';
      }
      return text.length < MAX_STRING
        ? text
        : text.substring(0, MAX_STRING) + '...';
    },
    balanceInventoryCheck(checkSheet) {
      this.$router.push({
        name: 'balance-inventory-check',
        query: { id: checkSheet.id },
      });
    },
    printItem(item) {
      this.$router.push({
        name: 'print-inventory-check',
        query: { id: item.id },
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kiểm tra tồn kho' },
      { title: 'Danh sách phiếu kiểm tra tồn kho' },
    ]);
    this.onFilter();
  },
  created() {
    this.fetchStoreByUser();
    this.fetchCompany();
  },
  components: {
    KTCodePreview,
    InventoryCheckAddModal,
    StatusLabel,
    BDropdownCustom,
    BPaginationNavCustom,
    VclTable,
    CompanyCodeBadge,
    EmployeeSearch,
  },
};
</script>

<style scoped>
.check-sheet-list {
  max-height: 600px !important;
  overflow-y: auto !important;
}

.table-centered td {
  vertical-align: middle;
}
</style>
